const applyBtnClickHandlerUtil = ({
    priceOverrideTableData,
    priceOverrideReason,
    pricingNotes,
    setPriceOverrideTableData,
    dispatch,
    setPriceOverrideDetails,
    setFilteredProduct,
    getUpdatedPriceOverridenData,
    filteredProduct,
    setReportUsageFormObj,
    isRPPriceOverride,
    reportPaymentGridData,
    getPriceInNumberDataType,
    setReportPaymentGridData,
    setPriceOverride,
    setRPPriceOverride,
    setPriceOverridePage,
}) => {    
    const data = priceOverrideTableData.map((d) => ({
        ...d,
        isOverrideApplied:
            (d.adjustedUsedQtyPrice || d.adjustedOtherQtyPrice) && true,
        overridenUnitPriceApplied:
            (d.adjustedUsedQtyPrice || d.adjustedOtherQtyPrice) &&
            d.overridenUnitPriceApplied &&
            true,
    }));
    const updatedPriceOverrideData = [...data];
    const dupPriceOverrideTableData = [...data];
    updatedPriceOverrideData.priceOverriddenReason = priceOverrideReason;
    updatedPriceOverrideData.pricingNotes = pricingNotes;
    setPriceOverrideTableData(updatedPriceOverrideData);
    dispatch(setPriceOverrideDetails(updatedPriceOverrideData));

    dispatch({
        type: 'SET_LOCAL_PRICE_OVERRIDE_REASON',
        payload: priceOverrideReason,
    });
    dispatch({
        type: 'SET_LOCAL_PRICE_COMMENTS',
        payload: pricingNotes,
    });
    const priceOverridenData = getUpdatedPriceOverridenData(
        filteredProduct,
        data
    );
    setFilteredProduct(priceOverridenData);
    setReportUsageFormObj((prevState) => {
        const reportUsageObj = {
            ...prevState,
            overridenReason: '',
            pricingNotes: '',
        };
        if (priceOverrideReason?.length > 0) {
            reportUsageObj.overridenReason = priceOverrideReason;
        } else {
            delete reportUsageObj.overridenReason;
        }
        if (pricingNotes?.length > 0) {
            reportUsageObj.pricingNotes = pricingNotes;
        } else {
            delete reportUsageObj.pricingNotes;
        }
        return reportUsageObj;
    });
    if (isRPPriceOverride) {
        const overriddenData = getUpdatedPriceOverridenData(
            reportPaymentGridData,
            dupPriceOverrideTableData.map((item) => {
                const overrideUnitPrice = item.usedQuantity
                    ? item.adjustedUsedQtyPrice
                    : item.adjustedOtherQtyPrice;
                return overrideUnitPrice
                    ? {
                          ...item,
                          overrideUnitPrice: overrideUnitPrice,
                          isPriceUpdated: item.isPriceOverrideDoneInUsage
                              ? getPriceInNumberDataType(item.overriddenPrice) !==
                                getPriceInNumberDataType(overrideUnitPrice)
                              : true,
                      }
                    : {
                          ...item,
                          overrideUnitPrice: item.isPriceOverrideDoneInUsage
                              ? item.adjustedUsedQtyPrice === null ||
                                item.adjustedOtherQtyPrice === null
                                  ? undefined
                                  : item.overrideUnitPrice
                              : undefined,
                          isPriceUpdated: item.isPriceOverrideDoneInUsage
                              ? true
                              : false,
                      };
            })
        );
        setReportPaymentGridData(overriddenData);
    }
    setPriceOverride(false);
    setRPPriceOverride(false);
    dispatch(setPriceOverridePage(false));
};

export default applyBtnClickHandlerUtil;